import request from '../request';
// 推荐公司和同城公司接口
export const getRelatedCompanies = (params) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v1/companies/related_companies',
    method: 'GET',
    params,
  })
}
